import React from 'react'
import { Box, Button, Container, Paper } from '@mui/material'
import { Outlet, useNavigate } from 'react-router-dom'
import { logoNoBackground } from 'assets'

/** Public layout for `/apply` — wide enough for the financing form, no auth required. */
const WebsiteApplyLayout: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        backgroundColor: theme => theme.palette.grey[100],
        paddingTop: '5vh',
        position: 'relative',
        pb: 4,
      }}
    >
      <Button
        onClick={() => navigate('/login')}
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          color: 'black',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
      >
        Sign in
      </Button>
      <Container component='main' maxWidth='md'>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box
            component='img'
            src={logoNoBackground}
            alt='Optic Truck Works Logo'
            sx={{
              width: '200px',
              height: 'auto',
              marginBottom: 4,
            }}
          />
          <Paper
            elevation={6}
            sx={{
              padding: { xs: 2, sm: 4 },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              bgcolor: 'white',
              width: '100%',
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            }}
          >
            <Outlet />
          </Paper>
        </Box>
      </Container>
    </Box>
  )
}

export default WebsiteApplyLayout
